exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../node_modules/css-loader/index.js!../node_modules/ag-grid-community/dist/styles/ag-grid.css"), "");
exports.i(require("-!../node_modules/css-loader/index.js!../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css"), "");

// module
exports.push([module.id, "#app {\n  font-family: \"Avenir\", Helvetica, Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-align: center;\n  color: #2c3e50;\n  /* // margin-top: 60px; */\n}\nh1,\nh2 {\n  font-weight: normal;\n}\na {\n  color: #42b983;\n}\n", ""]);

// exports
